__turbopack_context__.v({
  "tooltip": "StatusIndicator-module__VDsh4q__tooltip",
  "tooltipText": "StatusIndicator-module__VDsh4q__tooltipText",
});
